import {Zap} from 'lucide-react'
import {useLanguage} from '@/contexts/LanguageContext'

function CTASections() {
  const {t} = useLanguage()

  return (
    <>
      <section className="relative z-10 px-6 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <div className="rounded-2xl border border-indigo-400/30 bg-slate-900/70 p-10 md:p-12 shadow-lg shadow-indigo-500/10">
            <h2 className="text-3xl md:text-4xl font-bold mb-5 text-white">{t.cta.primaryTitle}</h2>
            <p className="text-lg text-gray-400 mb-8">{t.cta.primarySubtitle}</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://t.me/slavique"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-500 to-sky-400 text-white font-semibold shadow-lg shadow-indigo-500/30 hover:shadow-indigo-500/50 transition-all duration-300 hover:scale-[1.03] rounded-md text-base h-12 px-6"
              >
                <Zap className="w-5 h-5" />
                {t.cta.primaryButton}
              </a>
              <a
                href="https://drive.google.com/file/d/1lR6LbVKosJoUt6LBNARLwLIIu7VlTYEr/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center font-medium border border-white/20 text-white hover:bg-white/10 hover:border-white/40 transition-all duration-300 rounded-md text-base h-12 px-6"
              >
                {t.cta.secondaryButton}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="relative z-10 px-6 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <div className="rounded-2xl border border-white/10 bg-slate-900/60 p-10 md:p-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-5 text-white">{t.cta.ownerTitle}</h2>
            <p className="text-lg text-gray-400 mb-8">{t.cta.ownerSubtitle}</p>
            <a
              href="https://t.me/slavique"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-500 to-sky-400 text-white font-semibold shadow-lg shadow-indigo-500/30 hover:shadow-indigo-500/50 transition-all duration-300 hover:scale-[1.03] rounded-md text-base h-12 px-6"
            >
              <Zap className="w-5 h-5" />
              {t.cta.ownerButton}
            </a>
          </div>
        </div>
      </section>
    </>
  )
}

export default CTASections
